import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import * as _ from 'lodash';

//Constants
// import { PlanObjective } from '../../constants/PlanObjective.const';

//Enums
import { ChannelConst } from '../../constants/Channel.const';
import { AdvertiserInfoVO } from '../../../../interfaces/AdvertiserInfo';

@Component({
  selector: 'plan-settings',
  templateUrl: './plan-settings.component.html',
  styleUrls: ['./plan-settings.component.scss']
})
export class PlanSettingsComponent implements OnInit {
  @Input() group: FormGroup;
  @Input() isNew: boolean;
  @Input() isCopy: boolean;
  @Input() advertiserInfo: AdvertiserInfoVO;


  channels: Array<any> = [];
  dropdownSettings: any;
  selectedItems: Array<any> = [];
  selectedChannels: Array<any> = [];

  // objectives = PlanObjective;

  constructor() { }

  ngOnInit() {

    this.channelControl.patchValue(["DigitalVideo"]);
    this.mapChannelsData();
    this.dropdownSettings = {
      idField: 'id',
      textField: 'text',
      enableCheckAll: false,
      allowSearchFilter: false
    };
  }

  onItemSelect(item: any) {
    (this.channelControl.patchValue(_.map(this.selectedChannels, 'id')));
  }

  mapChannelsData() {
    let selectedChannelNames = this.group.controls.channels.value;
    _.forEach(ChannelConst, (value: any, key: string) => {
      this.channels.push({
        id: key,
        text: value.label,
        //Disable all the format for V1, by default DigitalVideo would be selected
        isDisabled: true
      });
    });

    this.selectedChannels = _.filter(this.channels, (env: any) => {
      return selectedChannelNames.findIndex((o: any) => { return o === env.id }) > -1;
    });
  }

  get name(): FormControl {
    return this.group.controls.name as FormControl;
  }

  get channelControl(): FormControl {
    return this.group.controls.channels as FormControl;
  }

}
